import { defineMessages } from 'react-intl';

export default defineMessages({
  cardIdentifierInputDormakabaHelper: {
    defaultMessage: 'Enter the card / fob identification number manually or scan the QR code',
    id: 'cardIdentifierInput.Dormakaba.helper',
  },
  credentialAssignFailed: {
    defaultMessage: 'Couldn’t assign this card or fob. Try again later.',
    id: 'userRfidModal.scanQR.msgErr.credentialAssignFailed',
  },
  scanQRButtonLabel: {
    defaultMessage: 'Scan QR code',
    id: 'scanQRButton.label',
  },
  scanQrbuttonLabel: {
    defaultMessage: 'Scan QR code',
    id: 'scanQRButton.label',
  },
  siteSettingsGeneralError: {
    defaultMessage: 'There was an error, please try again',
    id: 'siteSettings.general.error',
  },
  userRfidModalAlertCardAssignedText: {
    defaultMessage:
      'Each RFID card can only be assigned to one user within a site.' +
      ' This card is assigned to another {br}user.' +
      '{br}To change the card user, remove the card from the {link}.',
    description: 'RFID assign error - alert card already assigned',
    id: 'userRfidModal.alertCardAssigned.text',
  },
  userRfidModalAlertCardAssignedUserLink: {
    defaultMessage: "current user's detail",
    description: 'RFID assign error - link to user',
    id: 'userRfidModal.alertCardAssigned',
  },
  userRfidModalAssigneeText: {
    defaultMessage: 'This access card / fob will be assigned to:',
    description: 'User rfid modal - assignee text',
    id: 'userRfidModalAssigneeText',
  },
  userRfidModalCancelButton: {
    defaultMessage: 'Cancel',
    description: 'User rfid modal - cancel button',
    id: 'userRfidModalCancelButton',
  },
  userRfidModalCardDormakabaAlert: {
    defaultMessage: `Standard RFID cards and fobs won't work on Dormakaba devices. Switch to Dormakaba card / fob to ensure access.`,
    id: 'userRfidModal.card.Dormakaba.alert',
  },
  userRfidModalCardDormakabaHelper: {
    defaultMessage: 'Enter the printed ID or scan the QR code using the camera',
    id: 'userRfidModal.card.Dormakaba.helper',
  },
  userRfidModalCardDormakabaLabel: {
    defaultMessage: 'Dormakaba card / fob',
    id: 'userRfidModal.card.Dormakaba.label',
  },
  userRfidModalCardNormalHelper: {
    defaultMessage: 'Enter the ID manually or scan the card using an external USB reader.',
    id: 'userRfidModal.card.normal.helper',
  },
  userRfidModalCardNormalLabel: {
    defaultMessage: 'Standard RFID card / fob',
    id: 'userRfidModal.card.normal.label',
  },
  userRfidModalConfirmButton: {
    defaultMessage: 'Assign card',
    description: 'User rfid modal - confirm button',
    id: 'userRfidModalConfirmButton',
  },
  userRfidModalNewTitle: {
    defaultMessage: 'Assign RFID card',
    description: 'User rfid modal - title',
    id: 'userRfidModalNewTitle',
  },
  userRfidModalScanQRCloseBtn: {
    defaultMessage: 'Close scanner',
    id: 'userRfidModal.scanQR.closeBtn',
  },
  userRfidModalScanQrMsgErrCardNotRegistered: {
    defaultMessage: 'This card / fob can’t be assigned. ID not recognized',
    id: 'userRfidModal.scanQR.msgErr.cardNotRegistered',
  },
  userSnackbarRfidCardAssignedSuccessfully: {
    defaultMessage: 'Access card / fob assigned',
    id: 'userSnackbarRfidCardAssignedSuccessfully',
  },
});
